import * as React from 'react';
import { useState } from 'react';

export interface ContentRefContext {
    footerSize: number;
    appbarSize: number;
    contentSize: number;
    setAppbarSize: React.Dispatch<React.SetStateAction<number>>;
    setFooterSize: React.Dispatch<React.SetStateAction<number>>;
    setContentSize: React.Dispatch<React.SetStateAction<number>>;
}

const initState: ContentRefContext = {
    footerSize: 0,
    appbarSize: 0,
    contentSize: 0,
    setAppbarSize: () => {},
    setFooterSize: () => {},
    setContentSize: () => {},
};

const contentRefContext = React.createContext<ContentRefContext>(initState);

export function ContentRefProvider(props: Readonly<{ children: React.ReactNode }>): React.ReactElement {
    const [appbarSize, setAppbarSize] = useState<number>(0);
    const [footerSize, setFooterSize] = useState<number>(0);
    const [contentSize, setContentSize] = useState<number>(0);

    return (
        <contentRefContext.Provider
            value={{
                contentSize,
                setContentSize,
                footerSize,
                appbarSize,
                setAppbarSize,
                setFooterSize,
            }}
        >
            {props.children}
        </contentRefContext.Provider>
    );
}

export function useContentRefContext() {
    return React.useContext(contentRefContext);
}
